// extracted by mini-css-extract-plugin
export default {"mapcontainer":"index_mapcontainer__Rr8Mc"};